module.exports = __webpack_public_path__ + "img/radiantmediaplayer.e35b1e01.png";